import * as types from './action-types'

export const fetchCountries = () => ({
  type: types.COUNTRIES_FETCH_BEGIN,
})
